module.exports = __webpack_public_path__ + "img/forgetcurve.05004fca.jpg";